import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { myGraph, myGraphs, type GraphWindow } from "@/lib/api";
import { GraphImg } from "@/components/GraphImg";
import Card from "@/components/Card";
import PageHeader from "@/components/PageHeader";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useI18n } from "@/lib/i18n";

const WINDOWS: GraphWindow[] = ["6h", "24h", "7d", "30d"];

/**
 * The whole panel, for a port-viewer account: the graphs an admin assigned,
 * under the labels they chose. Device and interface names stay inside the NOC.
 */
export default function MyGraphsPage() {
  const { t } = useI18n();
  const [win, setWin] = useState<GraphWindow>("24h");
  const { data, isLoading } = useQuery({ queryKey: ["my-graphs"], queryFn: myGraphs });
  const graphs = data?.graphs ?? [];

  return (
    <div>
      <PageHeader
        title={t("myGraphs.title")}
        subtitle={t("share.subtitle")}
        right={
          <Tabs value={win} onValueChange={(v) => setWin(v as GraphWindow)}>
            <TabsList className="h-8">
              {WINDOWS.map((w) => (
                <TabsTrigger key={w} value={w} className="px-3 text-xs">{w}</TabsTrigger>
              ))}
            </TabsList>
          </Tabs>
        }
      />
      {isLoading ? (
        <p className="text-slate-400">{t("common.loading")}</p>
      ) : graphs.length === 0 ? (
        <Card title={t("myGraphs.title")}>
          <p className="text-slate-400">{t("myGraphs.empty")}</p>
        </Card>
      ) : (
        <div className="space-y-4">
          {graphs.map((g) => (
            <Card key={g.id} title={g.label}>
              <GraphImg
                queryKey={["my-graph", g.id, win]}
                fetch={(width) => myGraph(g.id, win, width)}
                alt={g.label}
              />
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
